import {
  CrmFieldService,
  StandardIds,
} from '@galaxy/crm/services/field-service';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../../i18n/translation-module';
import { RxState } from '@rx-angular/state';
import { map } from 'rxjs';
import { CollapsibleSectionComponent } from '../../collapsible-section/collapsible-section.component';
import { ActivityInterface } from '@vendasta/crm';
import { ActivityRichTextComponent } from './activity-rich-text.component';

@Component({
  selector: 'crm-activity-logged-note',
  templateUrl: './logged-note.component.html',
  providers: [RxState],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, TranslateModule, TranslationModule, CollapsibleSectionComponent, ActivityRichTextComponent],
})
export class CrmActivityLoggedNoteComponent {
  @Input() set activity(activity: ActivityInterface) {
    this.state.set({ activity: activity });
  }
  get activity() {
    return this.state.get().activity;
  }

  noteBody$ = this.state.select('noteBody');

  constructor(
    private readonly state: RxState<ComponentState>,
    private readonly fieldService: CrmFieldService,
  ) {
    this.state.set({
      activity: undefined,
      noteBody: '',
    });

    this.state.connect(
      'noteBody',
      this.state
        .select('activity')
        .pipe(
          map(
            (activity) =>
              this.fieldService.getFieldValueFromCrmObject(activity, StandardIds.ActivityNoteBody)?.stringValue ?? '',
          ),
        ),
    );
  }
}

interface ComponentState {
  activity: ActivityInterface;

  noteBody: string;
}
